import {objectToArray} from './objects';
import {Search as tSearch} from 'priority-web-sdk/enums';
import {getSortBy, getIsDesc} from './sortOptions';

export type Direction = 'ltr' | 'rtl' | 'auto';

export function searchToResults(result: tSearch = null) {
    if (result) {
        const ignorecase = result.ChooseLine ? true : result.ignorecase === '1';
        const searchFromBeginning = result.SearchLine ? result.start === '1' : !result.title2;
        let searchResults;

        if (result.ChooseLine) {
            searchResults = objectToArray(result.ChooseLine).map(({str1, str2, retval}) => ({
                string1: str1,
                string2: str2,
                retval
            }));
        } else {
            searchResults = objectToArray(result.SearchLine);
        }
        searchResults = searchResults.filter(({retval, string1, string2}) => {
            return retval || (string1 && string1.trim()) || (string2 && string2.trim());
        });
        const direction: Direction = result.cursor
            ? result.alignright === '1'
                ? 'rtl'
                : 'ltr'
            : 'auto';
        if (searchResults.length) {
            return {
                results: searchResults,
                isSearchable: !!result.SearchLine,
                isScrollable: result.next === '1',
                searchByTitle: result.cursor,
                searchFromBeginning,
                ignorecase,
                title1: result.title1,
                title2: result.title2,
                chooseid: result.chooseid,
                sortBy: getSortBy(result.sortby),
                isDesc: getIsDesc(result.sortby),
                inputValue: result.value ?? '',
                direction
            };
        } else {
            return {
                results: searchResults,
                searchByTitle: result.cursor,
                isSearchable: !!result.SearchLine,
                isZoom: !!result.zoom,
                ignorecase,
                searchFromBeginning,
                inputValue: result.value ?? '',
                direction
            };
        }
    }
    return {results: [], isSearchable: false};
}

function calculateSelectedIndexOnSearchable(results, searchQuery) {
    let selectedIndex;

    for (let i = 0; i < results.length; i++) {
        const str1 = results[i].string1 && results[i].string1.toLowerCase();
        const str2 = results[i].string2 && results[i].string2.toLowerCase();
        const str3 = results[i].string3 && results[i].string3.toLowerCase();

        if (str1 === searchQuery || str2 === searchQuery || str3 === searchQuery) {
            //if there is more than 1 equal result
            if (selectedIndex !== undefined) return -1;

            selectedIndex = i;
        }
    }
    return selectedIndex !== undefined ? selectedIndex : -1;
}
function calculateSelectedIndexOnNotSearchable(results, searchQuery) {
    let selectedIndex;

    for (let i = 0; i < results.length; i++) {
        const str1 = results[i].string1 && results[i].string1.toLowerCase();

        //if found an equal item to the search query.
        if (str1 === searchQuery) {
            return i;
        }

        if (selectedIndex === undefined && str1 && str1.startsWith(searchQuery.trim())) {
            selectedIndex = i;
        }
    }
    return selectedIndex !== undefined ? selectedIndex : 0;
}
export function calculateFocusedIndex(results, searchQuery, isSearchable) {
    if (results && results.length && searchQuery) {
        const lowercaseSearchQuery = searchQuery.toLowerCase();

        if (isSearchable) {
            return calculateSelectedIndexOnSearchable(results, lowercaseSearchQuery);
        }
        return calculateSelectedIndexOnNotSearchable(results, lowercaseSearchQuery);
    }
    return isSearchable ? -1 : 0;
}

export function calculateSelectedIndex(results, searchQuery) {
    if (results && results.length && searchQuery) {
        const lowercaseSearchQuery = searchQuery.toLowerCase();
        return calculateSelectedIndexOnSearchable(results, lowercaseSearchQuery);
    }
    return -1;
}

export function sortResults(results, sortByVal, isDesc) {
    return results.sort((res1, res2) => {
        const str1 = sortByVal === 'string1' ? res1.string1 : res1.string2;
        const str2 = sortByVal === 'string1' ? res2.string1 : res2.string2;
        const compareRes = str1 < str2 ? -1 : 1;
        return isDesc ? compareRes * -1 : compareRes;
    });
}
